import { jsx as o } from "react/jsx-runtime";
import { av as n, aw as b, x as p, d as s } from "../../../vendor-Dd6qj6gJ.js";
import { s as a } from "../../../shared.module-BNaUp3Ey.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as u } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index21.css';const $ = "_modal_2jij8_1", x = "_fullscreen_2jij8_20", d = {
  modal: $,
  fullscreen: x
};
function N({
  children: e,
  isAlert: t = !1,
  UNSAFE_fullscreen: c = !1,
  isDismissable: l = !0,
  ...r
}) {
  return /* @__PURE__ */ o(
    n,
    {
      ...u(r),
      isDismissable: l,
      isKeyboardDismissDisabled: !1,
      shouldCloseOnInteractOutside: () => l,
      className: s(a.overlay, a.backdrop),
      slot: void 0,
      children: ({ isEntering: f, isExiting: i }) => /* @__PURE__ */ o(
        b,
        {
          className: s(d.modal, a.surface, c && d.fullscreen),
          "data-component": "Modal",
          children: /* @__PURE__ */ o(
            p,
            {
              role: t ? "alertdialog" : "dialog",
              className: a.dialog,
              "aria-label": r["aria-label"],
              children: ({ close: m }) => typeof e == "function" ? e({ close: m, isEntering: f, isExiting: i }) : e
            }
          )
        }
      )
    }
  );
}
export {
  N as Modal
};
